module.exports = __webpack_public_path__ + "static/media/kres.2f17fd20.jpeg";